import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';

const OneOnOne = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    create: async (body: any) => {
      const result = await http.post('/performance-one-on-one', body, { headers });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/performance-one-on-one/${id}`, {
        headers,
      });
      return result.data;
    },
    listByEmployee: async (employeeId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/performance-one-on-one/by-employee/${employeeId}`, {
        headers,
        params,
      });
      return result.data;
    },
    listBySchool: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/performance-one-on-one/by-school/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    getPriorDiscussions: async (userId: string) => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
      });
      return result.data;
    },
    getUserOneOnOnes: async (userId: string, type: string = 'one-on-one') => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
        params: { type },
      });
      return result.data;
    },
    approve: async (id: string) => {
      const result = await http.patch(`/performance-one-on-one/${id}/approve`, {}, { headers });
      return result.data;
    },
    reject: async (id: string) => {
      const result = await http.delete(`/performance-one-on-one/${id}/reject`, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/performance-one-on-one/${id}`, { headers });
      return result.data;
    },
    update: async (id: string, body: any) => {
      const result = await http.put(`/performance-one-on-one/${id}`, body, { headers });
      return result.data;
    },
  };
};

export default OneOnOne;
